import { type QuillOptions } from "quill";
import ImageResize from "quill-image-resize-module-react";
import { Quill } from "react-quill-new";

interface BaseImageResize extends ImageResize {
  quill: Quill;
  box: HTMLElement;
  handleClick: (evt: MouseEvent) => void;
  hide: () => void;
}

type ImageResizeConstructor = new (quill: Quill, options: QuillOptions) => BaseImageResize;

export class ToggleableImageResize extends (ImageResize as ImageResizeConstructor) {
  enabled = true;

  constructor(quill: Quill, options: unknown) {
    super(quill, options);

    // We need to remove the
    this.quill.root.removeEventListener("click", this.handleClick);

    // Rebind the new version
    this.quill.root.addEventListener("click", this.clickHandler.bind(this));
  }

  setEnabled(enabled: boolean) {
    this.enabled = enabled;
    if (!enabled) {
      this.hide();
    }
  }

  clickHandler(event: MouseEvent) {
    if (!this.enabled) return;
    this.handleClick(event);
  }
}
